// @flow
import JQueryView from '../common/JQueryView';

declare var $: any;

export default class TopPageView extends JQueryView {
  constructor() {
    super('.index');
    document.addEventListener('turbolinks:before-cache', function() {
      $('.js-slick-hero.slick-initialized').slick('unslick');
      $('.js-slick.slick-initialized').slick('unslick');
      $('.js-slick-advance.slick-initialized').slick('unslick');
      $('.js-slick-top-shortly.slick-initialized').slick('unslick');
      $('.js-slick-market.slick-initialized').slick('unslick');
      $('.js-slick-news.slick-initialized').slick('unslick');
      $('.js-slick-hot.slick-initialized').slick('unslick');
    });
    $('.js-slick-hero')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        autoplay: true,
        speed: 1000,
        dots: false,
        swipe: true,
        arrows: false,
        centerMode: false,
        variableWidth: true,
        slidesToShow: 1,
        responsive: [
          {
            breakpoint: 1060,
            settings: {
              centerMode: true,
            },
          },
        ],
      });

    var projectNum = $('.index').find('.top-project .c-projectItem').length;
    var projectInfinite;
    var projectCenterMode;
    var projectSlidesToShow;

    if (projectNum < 5) {
      $('.top-project .l-container').addClass('-item-4');
      projectInfinite = false;
      projectCenterMode = false;
      projectSlidesToShow = projectNum;
    } else {
      projectInfinite = true;
      projectCenterMode = false;
      projectSlidesToShow = 3;
    }
    console.log(projectNum);
    console.log(projectInfinite);
    console.log(projectCenterMode);
    console.log(projectSlidesToShow);

    $('.js-slick')
      .not('.slick-initialized')
      .slick({
        infinite: projectInfinite,
        autoplay: false,
        dots: false,
        slidesToShow: projectSlidesToShow,
        swipe: true,
        arrows: true,
        touchMove: false,
        variableWidth: true,
        centerMode: projectCenterMode,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 3,
              swipe: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
          {
            breakpoint: 1060,
            settings: {
              slidesToShow: 2,
              infinite: true,
              swipe: true,
            },
          },
          {
            breakpoint: 775,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: true,
              swipe: true,
            },
          },
        ],
      });

    var advanceNum = $('.index').find('.top-advance .c-projectItem').length;
    var advanceInfinite;
    var advanceCenterMode;
    var advanceSlidesToShow;
    if (advanceNum < 5) {
      $('.top-advance .l-container').addClass('-item-4');
      advanceInfinite = false;
      advanceCenterMode = false;
      advanceSlidesToShow = advanceNum;
    } else {
      advanceInfinite = true;
      advanceCenterMode = false;
      advanceSlidesToShow = 3;
    }

    $('.js-slick-advance')
      .not('.slick-initialized')
      .slick({
        infinite: advanceInfinite,
        autoplay: false,
        autoplaySpeed: 100000000,
        dots: false,
        slidesToShow: advanceSlidesToShow,
        swipe: true,
        touchMove: false,
        arrows: true,
        variableWidth: true,
        centerMode: advanceCenterMode,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 1599,
            settings: {
              slidesToShow: 3,
              swipe: true,
            },
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              swipe: true,
            },
          },
          {
            breakpoint: 1060,
            settings: {
              slidesToShow: 2,
              infinite: true,
              swipe: true,
            },
          },
          {
            breakpoint: 775,
            settings: {
              slidesToShow: 1,
              centerMode: true,
              infinite: true,
              swipe: true,
            },
          },
        ],
      });

    $('.js-slick-top-shortly')
      .not('.slick-initialized')
      .slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 20000,
        cssEase: 'linear',
        slidesToShow: 3,
        dots: false,
        swipe: true,
        arrows: false,
        variableWidth: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        waitForAnimate: false,
        responsive: [
          {
            breakpoint: 834,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

    $('.js-slick-market')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        autoplay: false,
        dots: false,
        swipe: true,
        arrows: true,
        variableWidth: true,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 414,
            settings: {
              centerMode: true,
            },
          },
        ],
      });

    $('.js-slick-news')
      .not('.slick-initialized')
      .slick({
        infinite: false,
        autoplay: false,
        dots: false,
        swipe: true,
        arrows: true,
        variableWidth: true,
        slidesToScroll: 2,
        slidesToShow: 4,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 834,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

    $('.js-slick-hot')
      .not('.slick-initialized')
      .slick({
        infinite: true,
        autoplay: false,
        dots: false,
        swipe: true,
        arrows: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        // variableWidth: true,
        prevArrow: '<button class="slide-arrow slick-prev"></button>',
        nextArrow: '<button class="slide-arrow slick-next"></button>',
        responsive: [
          {
            breakpoint: 834,
            settings: {
              slidesToShow: 1,
              centerMode: true,
            },
          },
        ],
      });

    $('.tab-group li').on('click', function() {
      let s = $(this).data('tab');
      $('.tab-group li').removeClass('is-active');
      $('[data-tab="' + s + '"]').addClass('is-active');
    });
  }
}
